import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { getDashboardCampus } from "../../../api/dashboard.api";
import useAxios from "../../../hooks/useAxios";
import { IGetDashboardCampus } from "../../../models/dashboard.model";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";

const CampusStatus = () => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetDashboardCampus>();

  useEffect(() => {
    execute(getDashboardCampus());
  }, []);

  return (
    <>
      {isLoading && <Loader />}    
      <ErrorResponse error={error} />

      <div className='comm-table__area'>
        <table>
          <colgroup>
            <col width="33%" />
            <col width="33%" />
            <col width="33%" />
          </colgroup>
          <thead>
            <tr>
              <th className="font-weight-bold">{t('class.dashboard.column1')}</th>
              <th className="font-weight-bold">{t('class.dashboard.column2')}</th>
              <th className="font-weight-bold">{t('class.dashboard.column3')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{res?.data?.openCount}</td>
              <td>{res?.data?.readyCount}</td>
              <td>{res?.data?.closeCount}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default CampusStatus;
